export class SelectableItem {
    id: number;
    value: any;
    localizationKeyName: string;
    icon: any;
}